export default {
    selectCardReaders: 'Select Card Readers',
    intercomSettings: 'Intercom Label Settings',
    visitorBtnLabel: 'Visitor button label',
    visitorFieldHint: 'Would change the visitor button label that is displayed on the swift reader screen',
    tenantBtnLabel: 'Tenant intercom label',
    tenantFieldHint:
        'Would change the `call tenant` button label , which is displayed on swift reader when you click on visitor  option when tenant intercom is enabled.',
    frontDeskBtnLabel: 'Front desk button label',
    frontDeskFieldHint:
        'Would change the front desk button label , which is displayed on swift reader when you click on visitor  option when front desk intercom is enabled.',
    deviceVolume: 'Device volume',
    volumeHelpTxt: 'Adjust the volume of swift-reader',
    apiCallsLimits: 'Swift Reader Daily Action Limits',
    dailyLimit: 'Daily Limit',
    callsMade: 'Calls Made',
    callsLeft: 'Calls Left',
    sitesAndAccessPoints: 'Sites & Access Points',
    addNewSite: 'Add a new Site',
    siteName: 'Site Name',
    address: 'Address',
    typeSearchPlaces: 'Type and search for places',
    timezone: 'Timezone',
    selectTimezone: 'Select Timezone',
    country: 'Country',
    selectCountry: 'Select Country',
    phoneNumber: 'Phone Number',
    pleaseCheckPhoneNumber: 'Please enter a valid 10 digit phone number',
    addSite: 'Add Site',
    editSite: 'Edit Site',
    selectSite: 'Select Site',
    pleaseSelectSite: 'Please Select Site',
    unlock: 'Unlock',
    selectSection: 'Select Section',
    accessPointDetails: 'Access Point Details',
    doorOverride: {
        lockTemporarily: 'Lock temporarily',
        keepUnlocked: 'Keep unlocked',
        resumeSchedule: 'Resume schedule',
        endNow: 'End now',
        lock: 'Lock',
        unlock: 'Unlock',
        untilWindowEnds: 'Until this window ends',
        custom: 'Custom',
        minutes: 'Minutes',
        // Final review F3 (ruling): an offline device can stay "pending" for the whole override, so the pending line
        // still says when it ends. No " by NAME" while pending.
        locking: (time: string): string => `Locking… until ${time}`,
        unlocking: (time: string): string => `Unlocking… until ${time}`,
        unlockedBySchedule: 'Unlocked by schedule',
        until: 'until',
        lockedUntil: (time: string, by?: string | null): string => (by ? `Locked until ${time} by ${by}` : `Locked until ${time}`),
        unlockedUntil: (time: string, by?: string | null): string => (by ? `Unlocked until ${time} by ${by}` : `Unlocked until ${time}`),
        lockIntroUnlockedBy: 'is unlocked by the schedule',
        lockIntroLockItFor: 'Lock it for:',
        // Fallback when the schedule's window end is unknown: "Lock <b>door</b> for:".
        lockIntroPrefix: 'Lock',
        lockIntroSuffix: 'for:',
        keepIntroNoSchedule: 'No schedule is holding',
        keepIntroKeepItFor: 'open right now. Keep it unlocked for:',
        lockHint: 'The door locks now and unlocks again at',
        // Used when the lock runs to the window end: at that moment the schedule stops holding the door open, so it stays locked.
        lockHintWindow: 'The door locks now and stays locked for the rest of this schedule window, which ends at',
        keepHintCap: (hours: number): string => `Up to ${hours} ${hours === 1 ? 'hour' : 'hours'} for this workspace.`,
        keepHintLocksAgain: 'The door locks again at',
        resumeConfirm: 'Return this door to its schedule now?',
        endNowConfirm: 'Lock this door again now?',
        pleaseChooseDuration: 'Please choose how long.',
        customInPast: 'Choose a time in the future.',
        customTooLong: (hours: number): string => `Choose a time within the next ${hours} ${hours === 1 ? 'hour' : 'hours'}.`,
    },
};
